import { makeStyles } from "@material-ui/core/styles";
import { toolbarHeight } from "components/app/Styles";
import theme from "theme";
export const filterContainerHeight = 83;
export const chartTitleHeight = 33;
export const aboutDrawerWidth = 345;
export const chartDrawerWidth = 390;
export const chartTogglebarWidth = 68;
export const aboutTogglebarWidth = 68;

const useStyles = makeStyles({
  "@global": {
    html: {
      height: "100%",
    },
    body: {
      margin: "0",
      height: "100%",
      fontFamily: "Arial, sans-serif",
    },
  },
  filterContainer: {
    minHeight: filterContainerHeight,
    // width: "100%", <- this leaves a small gap at the end of screen
    width: `calc(100vw + 8px)`,
    backgroundColor: "#E5E9EE",
    display: "flex",
    alignItems: "center",
    paddingLeft: 64,
    paddingRight: 64,
    paddingTop: 8,
    // paddingBottom: 8,
    boxShadow: "0px 3px 6px #00000029",
    position: "absolute",
    cursor: "pointer",
    zIndex: 1,
  },
  expandBtn: {
    background: "#FFFFFF",
    position: "absolute",
    bottom: -10,
    left: `calc(50vw - 35px)`,
    maxHeight: 25,
    paddingLeft: 8,
    paddingRight: 8,
    boxShadow: "0px 3px 6px #00000029",
    border: 0,
    color: "#757575",
    fontSize: 14,
    "& .MuiButton-startIcon": {
      marginRight: 0,
    },
    "&:hover": {
      background: "#FFFFFF",
    },
  },
  applyBtn: {
    marginTop: 24,
    textTransform: "uppercase",
  },
  filterSelect: {
    borderRadius: 0,
    minWidth: 200,
    marginTop: 16,
    marginBottom: 8,
    marginRight: 16,
    height: 61,
    "& .MuiOutlinedInput-input": {
      padding: 8,
      fontSize: 16,
    },
    "& .MuiInput-formControl": {
      marginTop: 24,
      paddingTop: 4,
      marginBottom: 8,
      border: "1px solid #ccc",
    },
    "& .MuiInput-underline:before": {
      borderBottom: 0,
      "&:hover": {
        borderBottom: 0,
      },
    },
    "& .MuiSelect-icon": {
      marginRight: 8,
    },
    "& .MuiSelect-select": {
      paddingLeft: 16,
      marginBottom: 4,
    },
  },
  filterSelectLabel: {
    marginBottom: 4,
  },
  chips: {
    display: "flex",

    alignItems: "center",
  },
  chip: {
    color: "#707070",
    paddingTop: 18,
    paddingBottom: 18,
    paddingLeft: 25,
    paddingRight: 25,
    borderRadius: 40,
    fontSize: 12,
    marginRight: 18,
    "& .MuiChip-label": {
      padding: 0,
    },
  },
  mainView: {
    position: "fixed",
    top: `calc(${toolbarHeight}px + ${filterContainerHeight}px)`,
  },
  chartTogglebar: {
    width: chartTogglebarWidth,
    display: "flex",
    flexDirection: "row",
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    backgroundColor: "#323232",
    boxShadow: "0px 3px 6px #00000080",
  },
  chartToggleIcon: {
    width: 26,
    height: 15,
    paddingTop: 36,
    paddingBottom: 36,
    paddingLeft: 21,
    paddingRight: 21,
    cursor: "pointer",
  },
  chartTabs: {
    display: "inline-flex",
    alignItems: "start",
    "& .MuiTabs-indicator": {
      display: "none",
    },
    "& .Mui-selected": {
      background: "#718CD4",
      "&:hover": {
        background: "#718CD4",
      },
    },
  },
  chartTab: {
    minWidth: 68,
    marginBottom: 8,
    paddingBottom: 0,
    paddingTop: 0,
    backgroundColor: "#1E1E1E",
    opacity: 1,
    marginTop: 0,
    "&:hover": {
      backgroundColor: "#4B5A84",
    },
    height: `calc(100vh / 5 - ${filterContainerHeight}px)`,
  },
  chartIconPlaceholder: {
    height: 120,
    width: "1.1em",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  chartDrawer: {
    width: chartDrawerWidth,
    position: "absolute",
    zIndex: 500,
    top: 0,
    left: 68,
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    backgroundColor: "#F5F5F5",
    boxShadow: "0px 3px 6px #00000060",
  },
  chartHeader: {
    // width: `100%`,
    height: chartTitleHeight,
    paddingTop: 26,
    paddingLeft: 64,
    display: "flex",
    justifyContent: "space-between",
  },
  chartHeaderResponsive: {
    height: 50,
    paddingTop: 26,
    paddingLeft: 20,
  },
  chartHeaderTitle: {
    color: "#2352D0",
    fontSize: 30,
    fontWeight: "bold",
  },
  chartHeaderSubtitle: {
    color: "#000",
    fontSize: 18,
    fontWeight: "bold",
  },
  chartHeaderTitleResponsive: {
    color: "#2352D0",
    fontSize: 16,
    fontWeight: "bold",
  },
  chartHeaderSubtitleResponsive: {
    color: "#000",
    fontSize: 12,
    fontWeight: "bold",
  },
  chartItem: {
    // height: 120,
    height: `calc(100vh / 5 - ${filterContainerHeight}px)`,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    paddingLeft: 32,
    paddingRight: 5,
    background: "#E9E9EB",
    marginBottom: 8,
  },
  chartItemTitle: {
    fontSize: 18,
    fontWeight: "bold",
    color: "#383737",
    "&:hover": {
      cursor: "pointer",
    },
    marginRight: "5em",
  },
  chartItemDesc: {
    fontSize: 14,
    "&:hover": {
      cursor: "pointer",
    },
  },
  chart: {
    paddingLeft: 54,
    paddingRight: 54,
  },
  chooseText: {
    fontSize: 30,
    fontWeight: "bold",
    color: "#212121",
    flexGrow: 1,
  },
  aboutTogglebar: {
    width: aboutTogglebarWidth,
    display: "flex",
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    background: "#FFFFFF",
    boxShadow: "0px 3px 6px #00000029",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    position: "relative",
  },
  aboutToggleIcon: {
    width: 37,
    height: 27,
  },
  aboutDrawer: {
    width: aboutDrawerWidth,
    background: "#FFFFFF",
    boxShadow: "0px 3px 6px #00000029",
    // height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    height: '100vh', // enable scrolling
    overflow: "auto",
    position: "relative",
    zIndex: 460,
  },
  metricTitle: {
    marginTop: 16,
    fontSize: 13,
    marginRight: 20, //this is mainly for the gaugePie metric title chart tab
  },
  gaugeMetricValue: {
    color: "#000000",
    fontSize: 13,
    fontWeight: "bold",
  },
  metricValue: {
    color: "#000000",
    fontSize: 18,
    fontWeight: "bold",
    // marginBottom: 40,
  },
  closeBtn: {
    position: "relative",
    left: "93%",
  },
  mapChartView: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    width: `calc(100vh - ${aboutDrawerWidth}px)`,
    background: "#E5E9EE",
  },
  chartView: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    // width: `calc(100vh - ${aboutDrawerWidth}px)`,
    background: "#E5E9EE",
  },

  irrigationChartView: {
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    height: `calc(100vh - ${toolbarHeight}px - ${filterContainerHeight}px)`,
    // width: `calc(100vh - ${aboutDrawerWidth}px)`,
    background: "#E5E9EE",
    justifyContent : "center",
    alignItems : "center",
  },
  mapContainer: {
    display: "flex !important",
  },
  tabs: {
    flexBasis: "auto",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    marginBottom: "2vh",
    marginTop: -20,
  },
  tabRoot: {
    "& .MuiTab-wrapper": {
      // textTransform: "uppercase",
    },
    "& .MuiTabs-indicator": {
      background: "none",
    },
  },
  tabInactive: {
    background: "#FFFFFF",
    color: "#757575",
    minWidth: "auto",
    minHeight: "auto",
    padding: "10px 12px",
    opacity: 1,
    font: "normal normal normal 12px/14px Arial",
    border: "0.5px solid #B8B8B8",
    "& .MuiTab-wrapper": {
      width: "auto",
    },
    [theme.breakpoints.up("xl")]: {
      font: "normal normal normal 16px/18px Arial",
    },
  },
  tabActive: {
    opacity: 1,
    background: "#EBF0FD",
    color: "#2352D0",
  },
  startingTab: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
  },
  endingTab: {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
  },
  sectionTitle: {
    fontSize: 18,
    fontWeight: "bold",
  },
  sectionContent: {
    marginTop: 8,
    marginBottom: 24,
    "& a:link, a:visited": {
      color: "#00A4E0",
    },
  },
  aboutBox: {
    height: "80%",
    overflow: "auto",
  },
  sliderContainer: {
    padding: 8,
    paddingLeft: 48,
    paddingRight: 48,
    backgroundColor: "#FFF",
    width: `calc(100vw - ${aboutDrawerWidth}px - 480px)`,
    display: "flex",
    justifyContent: "center",
    borderRadius: 10,
    boxShadow: "0px 3px 6px #00000029",
  },
  citySliderRail: {
    backgroundColor: "#C4C4C4",
    height: "5px",
    borderRadius: 4,
    opacity: 1,
  },
  citySliderTrack: {
    height: "5px",
    borderRadius: 4,
  },
  citySliderThumb: {
    height: 15,
    width: 15,
    border: "2px solid currentColor",
    marginTop: -5,
  },
  citySlider: {
    color: "#9CC9F5",
    marginTop: "4px",
  },
  citySliderMark: {
    backgroundColor: "#2F2F2F",
    width: 5,
    height: 5,
    borderRadius: 6,
  },
  cityMarkLabel: {
    color: "#2F2F2F",
    // font: "normal normal normal 11px/12px Arial",
    fontSize: "16px",
    fontFamily: "Arial",
  },
  map: {
    height: `calc(100vh - 156px)`,
  },
  mapResponsive: {
    height: `calc(100vh - 200px)`,
  },
  mapArea: {
    "& .info": {
      padding: "5px",
      font: "0.8em Arial, Helvetica, sans-serif",
      background: "rgba(255, 255, 255, 1)",
      boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
      borderRadius: "15px",
      margin: "0px 30px 20px",
    },
    "& .legendTitle": {
      // font: "normal normal bold 1.1em/30px Arial",
      fontFamily: "Arial",
      fontSize: "1.2em",
      fontWeight: "bold",
      color: "#2F2F2F",
      margin: "10px",
    },
    "& .legend": {
      lineHeight: "1vh",
      left: "20px",
    },
    "& .legend i": {
      width: "16px",
      height: "16px",
      float: "left",
      marginRight: "13px",
      opacity: "0.6",
      // borderRadius: "10px",
    },
    "& .legendLabel": {
      // font: "normal normal normal 1.2em/16px Arial",
      fontFamily: "Arial",
      fontSize: "16px",
      color: "#2F2F2F",
    },
    "& .legendContent": {
      // font: "normal normal normal 1.2em/16px Arial",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
    "& .leaflet-top": {
      // ensure leaflet controls on top appear below the title
      // the chartheader has a padding of 50, so we add 55
      top: `${chartTitleHeight + 55}px`,
    },
    "& .leaflet-bottom.leaflet-left": {
      // changes zIndex so legend appears below chart drawer
      zIndex: 451,
    },
    "& .leaflet-bottom": {
      // 200px is the width of the slider container
      left: `calc((100% - 200px) / 2)`,
    },
    "& .patternLegend": {
      background: `repeating-linear-gradient(
        135deg,
        #FFFFFF,
        #FFFFFF 2px,
        #808080 2px,
        #808080 5px
      )`,
    },
    "& .industryLegend": {
      border: "1px solid #A7A5A4 ",
      borderRadius: "10px",
    },
  },
  mapAreaResponsive: {
    "& .info": {
      padding: "5px",
      font: "0.8em Arial, Helvetica, sans-serif",
      background: "rgba(255, 255, 255, 1)",
      boxShadow: "0 0 15px rgba(0, 0, 0, 0.2)",
      borderRadius: "15px",
      margin: "0px 30px 20px",
    },
    "& .legendTitle": {
      // font: "normal normal bold 1.1em/30px Arial",
      fontFamily: "Arial",
      fontSize: "1.2em",
      fontWeight: "bold",
      color: "#2F2F2F",
      margin: "10px",
    },
    "& .legend": {
      lineHeight: "1vh",
      left: "10px",
    },
    "& .legend i": {
      width: "16px",
      height: "16px",
      float: "left",
      marginRight: "13px",
      opacity: "0.6",
      // borderRadius: "10px",
    },
    "& .legendLabel": {
      // font: "normal normal normal 1.2em/16px Arial",
      fontFamily: "Arial",
      fontSize: "16px",
      color: "#2F2F2F",
    },
    "& .legendContent": {
      // font: "normal normal normal 1.2em/16px Arial",
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      paddingLeft: "10px",
      paddingRight: "10px",
    },
    "& .leaflet-top": {
      // ensure leaflet controls on top appear below the title
      // the chartheader has a padding of 50, so we add 55
      top: `${chartTitleHeight}px`,
    },
    "& .leaflet-bottom.leaflet-left": {
      // changes zIndex so legend appears below chart drawer
      zIndex: 451,
    },
    "& .leaflet-bottom": {
      // 200px is the width of the slider container
      left: `calc((100% - 200px) / 2)`,
    },
    "& .patternLegend": {
      background: `repeating-linear-gradient(
        135deg,
        #FFFFFF,
        #FFFFFF 2px,
        #808080 2px,
        #808080 5px
      )`,
    },
    "& .industryLegend": {
      border: "1px solid #A7A5A4 ",
      borderRadius: "10px",
    },
  },
  mapSliderContainer: {
    backgroundColor: "#FFFFFF ",
    boxShadow: "0px 3px 6px #00000029",
    padding: "10px 10px 15px 10px",
    border: "1px solid #E0E0E0",
    borderRadius: "15px",
    height: "250px",
    width: "40px",
  },
  sliderTitle: {
    color: "#2F2F2F",
    // display: "block",
    font: "normal normal bold 13px/18px Arial",
    display: "flex",
    justifyContent: "center",
    // marginBottom: "12px",
    [theme.breakpoints.down("xl")]: {
      font: "normal normal bold 13px/18px Arial",
    },
    [theme.breakpoints.down("lg")]: {
      font: "normal normal bold 12px/16px Arial",
    },
  },
  sliderRail: {
    backgroundColor: "#C4C4C4",
  },
  slider: {
    color: "#9CC9F5",
    marginTop: "4px",
  },
  sliderVertical: {
    "&.MuiSlider-root": {
      height: "80% ",
      padding: "0 45%",
    },
    "&.MuiSlider-marked": {
      marginRight: "0px",
    },
    "& .MuiSlider-rail": {
      width: "5px",
      borderRadius: 4,
    },
    "& .MuiSlider-track": {
      width: "5px",
      borderRadius: 4,
    },
  },
  sliderValueLabel: {
    display: "none",
  },
  sliderThumb: {
    height: 15,
    width: 15,
    border: "2px solid currentColor",
    marginTop: -8,
  },
  sliderLabel: {
    font: "1em",
    display: "flex",
    justifyContent: "center",
  },
  chartContainer: {
    // paddingLeft: 54,
    // paddingRight: 54,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "15px",
    marginBottom: "15px",
    flexDirection: "column",
  },
  centralSliderRail: {
    backgroundColor: "#C4C4C4",
    height: "5px",
    borderRadius: 4,
    opacity: 1,
  },
  centralSliderTrack: {
    height: "5px",
    borderRadius: 4,
    backgroundColor: "currentColor !important",
  },
  centralSliderTrackInverted: {
    height: "5px",
    borderRadius: 4,
  },
  centralSliderThumb: {
    height: 15,
    width: 15,
    marginTop: -5,
  },
  centralSlider: {
    color: "#9CC9F5",
    marginTop: "4px",
    width: "85%",
  },
  centralSliderMark: {
    backgroundColor: "#2F2F2F",
    width: 5,
    height: 5,
    borderRadius: 6,
  },
  centralMarkLabel: {
    color: "#2F2F2F",
    // font: "normal normal normal 11px/12px Arial",
    fontSize: "0.9em",
    fontFamily: "Arial",
    transform: "translateX(50%)",
  },
  centralmapSliderContainer: {
    backgroundColor: "#FFFFFF ",
    boxShadow: "0px 3px 6px #00000029",

    border: "1px solid #E0E0E0",
    borderRadius: "15px",
    // height: "250px",
    width: "400px",
    display: "flex",
    justifyContent: "center",
  },
  technicalTooltipPopper: {
    padding: "9px 6px",
    font: "normal normal normal 0.85em/13px Arial",
  },
  sankeyTitle: {
    marginTop: 18,
    fontSize: "16px",
    fontWeight: "bold",
    fontFamily: "Arial",
    color: "rgb(102, 102, 102)",
  },
  aboutDrawerResponsive: {
    flex: 1,
    background: "#FFFFFF",
    boxShadow: "0px 3px 6px #00000029",
    zIndex: 460,
  },
  aboutTogglebarResponsive: {
    height: 68,
    flex: 1,
    background: "#FFFFFF",
    boxShadow: "0px 3px 6px #00000029",
    cursor: "pointer",
    zIndex: 100,
    position: "absolute",
    bottom: 0,
  },
  aboutToggleIconResponsive: {
    width: 37,
    height: 27,
    transform: "rotate(90deg)",
  },
  guagePieContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "10px",
  },
  startingTabIrrigation: {
    borderTopRightRadius: 5,
    borderBottomRightRadius: 5,
    width: "200px",
  },
  endingTabIrrigation: {
    borderTopLeftRadius: 5,
    borderBottomLeftRadius: 5,
    width: "200px",
  },
  irrigationContainer: {
    // paddingLeft: 54,
    // paddingRight: 54,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "30px",
    marginBottom: "15px",
    flexDirection: "column",
  },
  irrigationTabs: {
    flexBasis: "auto",
    display: "flex",
    justifyContent: "center",
    alignContent: "center",
    // marginBottom: "2vh",
  },
  locationFilterBox: {
    marginRight: "20px",
  },
  priorityCheckboxLabel: {
    fontSize: 16,
    alignContent: "left",
  },
  groupName: {
    fontSize: 15,
    marginLeft: 10,
    fontWeight: "bold",
  },
  accordion: {
    border: "1px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  },
  middleAccordion: {
    border: "5px solid rgba(0, 0, 0, .125)",
    boxShadow: "none",
    "&:not(:last-child)": {
      borderBottom: 0,
    },
    "&:before": {
      display: "none",
    },
  },
  accordionExpanded: {
    "&$expanded": {
      margin: 0,
    },
  },
  accordionSummary: {
    // backgroundColor: "rgba(0, 0, 0, .03)",
    borderBottom: "1px solid rgba(0, 0, 0, .125)",
    marginBottom: -1,
    minHeight: 53,
    "&$expanded": {
      minHeight: 53,
    },
    // flexDirection: "row-reverse",
    "& .icon": {
      fontSize: 12,
    },
  },
  accordionSummaryExpanded: {
    "& .MuiAccordionSummary-expandIcon": {
      // transform: "rotate(90deg)",
    },
  },
  accordionDetails: {
    // backgroundColor: "rgba(0, 0, 0, .03)",
    justifyContent: "center",
    flexDirection: "column",
    // padding: "0px 40px 10px 40px",
  },
  aboutContent: {
    marginTop: 16,
    fontSize: 13,
  },
  aboutScenario: {
    marginTop: 5,
    fontSize: 13,
  },
  aboutScenarioTitle: {
    marginTop: 16,
    fontSize: 13,
    fontWeight: "bold",
  },
  metricsContainer: {
    display: "flex",
    // justifyContent: "flex-start",
  },
});

export default useStyles;
